export default [
// {
//     path: 'join',
//     name: 'landingJoin',
//     meta: {
//         title: 'meeting.join_meeting',
//     },
//     component: () => import('@views/app/meeting/join' /* webpackChunkName: "js/app/meeting/join" */ ),
// }, 
]
